import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './index.css'

// 🛡️ CRITICAL: Initialize Security Framework FIRST
import './security/DatabaseGuardian.js'
import './security/RuntimeMonitor.js'

console.log('🛡️ MARKET GENIE SECURITY FRAMEWORK ACTIVATED');
console.log('🔒 ABSOLUTE DATABASE ISOLATION ENFORCED');

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
)
